import { configureStore } from "@reduxjs/toolkit";
import searchReducer from "./slices/searchSlice";
import themeReducer from "./slices/themeSlice"
import authReducer from "./slices/authSlice";
import pairReducer from "./slices/tradeSlice";
import kycReducer from "./slices/kycSlice";
import priceReducer from "./slices/priceSlice";
import twoFactorSlice from "./slices/twoFactorSlice";
import walletReducer from "./slices/walletSlice"
import p2pReducer from "./slices/p2pSlice";
import stakeReducer from "./slices/stakeSlice";
import tradeReducer from "./slices/tradeSlice"
import historyReducer from "./slices/historySlice"
import supportReducer from "./slices/supportSlice";

export const store = configureStore({
  reducer: {
    search: searchReducer,
    theme: themeReducer,
    auth: authReducer,
    pair: pairReducer,
    kyc: kycReducer,
    price: priceReducer,
    twofactor: twoFactorSlice,
    wallet: walletReducer,
    p2p: p2pReducer,
    stake: stakeReducer,
    trade: tradeReducer,
    history: historyReducer,
    support: supportReducer
  },
});

// Infer RootState and AppDispatch types
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
